// Hindi translations for Hipro Technologies
const hi = {
  meta: { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },

  nav: {
    home: 'होम', about: 'हमारे बारे में', services: 'सेवाएँ', portfolio: 'पोर्टफोलियो',
    pricing: 'मूल्य निर्धारण', industries: 'उद्योग', insights: 'लेख', contact: 'संपर्क',
    bookFreeCall: 'निःशुल्क कॉल बुक करें',
  },

  common: {
    getFreeConsultation: 'निःशुल्क परामर्श लें',
    exploreServices: 'सेवाएँ देखें',
    viewDetails: 'विवरण देखें',
    bookAppointment: 'निःशुल्क अपॉइंटमेंट',
    choosePackage: 'पैकेज चुनें',
    scheduleCall: 'कॉल शेड्यूल करें',
    talkToSales: 'बिक्री से बात करें',
    readArticle: 'लेख पढ़ें',
    viewAllPortfolio: 'सारा पोर्टफोलियो देखें',
    viewAllInsights: 'सारे लेख देखें',
    requestCustomQuote: 'कस्टम कोट माँगें',
    backHome: 'होम पर वापस',
    backToPortfolio: 'पोर्टफोलियो पर वापस',
    trustedWorldwide: 'दुनियाभर के व्यवसायों का भरोसा',
    isoCertified: 'ISO 27001 और ISO 9001 प्रमाणित',
    all: 'सभी',
    allIndustries: 'सभी उद्योग',
    industryLabel: 'उद्योग',
    chatOnWhatsapp: 'व्हाट्सएप पर चैट',
    submitting: 'भेजा जा रहा है…',
    loading: 'लोड हो रहा है…',
  },

  hero: {
    badge: 'ISO/IEC 27001:2022 और ISO 9001:2015 प्रमाणित टेक्नोलॉजी कंपनी',
    titleA: 'AI-संचालित', titleB: 'सॉफ्टवेयर', titleC: ',',
    titleD: 'क्लाउड और डिजिटल विकास', titleE: 'भागीदार', titleF: '.',
    subtitleLead: 'व्यवसायों का भरोसा',
    countries: 'USA, UK, UAE, नीदरलैंड, मलेशिया, हांगकांग और भारत',
    subtitleRest: 'में — तेज़ी से बनाने, बढ़ाने और स्केल करने के लिए। कस्टम सॉफ्टवेयर और वेबसाइट से AI ऑटोमेशन, SEO और मोबाइल ऐप तक — हम डिजिटल समाधान डिलीवर करते हैं जो लीड बढ़ाते हैं, रेवेन्यू बढ़ाते हैं और विकास तेज़ करते हैं।',
    stats: {
      years: 'साल का अनुभव', offices: 'ग्लोबल ऑफिस',
      projects: 'प्रोजेक्ट डिलीवर', retention: 'क्लाइंट रिटेंशन',
    },
  },

  form: {
    title: 'विशेषज्ञ से बात करें',
    subtitle: '24 घंटों में निःशुल्क परामर्श और प्रोजेक्ट अनुमान पाएँ।',
    ribbon: 'निःशुल्क स्ट्रैटेजी कॉल बुक करें',
    name: 'नाम*', namePh: 'आपका पूरा नाम',
    email: 'ईमेल*', emailPh: 'aap@company.com',
    mobile: 'मोबाइल नंबर*', mobilePh: 'मोबाइल नंबर',
    selectService: 'सेवा चुनें*', servicePh: '---- सेवा चुनें ----',
    hear: 'हमारे बारे में कहाँ सुना?*', hearPh: '---- विकल्प चुनें ----',
    submit: 'निःशुल्क कॉल बुक करें',
    success: 'अनुरोध प्राप्त हुआ',
    successDesc: 'Hipro विशेषज्ञ 24 घंटों में आपसे संपर्क करेंगे।',
    validation: 'कृपया आवश्यक फ़ील्ड भरें',
    validationDesc: 'नाम, ईमेल और मोबाइल आवश्यक हैं।',
    error: 'भेज नहीं सका',
  },

  about: {
    kicker: '2015 में स्थापित। 2010 से नेतृत्व अनुभव।',
    titleA: 'विश्वभर के व्यवसायों का',
    titleB: 'भरोसा',
    body: 'पिछले एक दशक में, Hipro Technologies ने कई उद्योगों में व्यवसायों को वेबसाइट, सॉफ्टवेयर प्लेटफ़ॉर्म और डिजिटल उत्पाद बनाने में मदद की है। USA, UK, UAE, नीदरलैंड, मलेशिया, हांगकांग और भारत में टीमों के साथ, हम स्थानीय पार्टनरशिप के साथ एंटरप्राइज़-ग्रेड इंजीनियरिंग देते हैं।',
    features: [
      { t: '7 देश', d: 'USA, UK, UAE, नीदरलैंड, मलेशिया, हांगकांग और भारत में डिलीवरी केंद्र।' },
      { t: 'ISO प्रमाणित', d: 'ISO/IEC 27001:2022 और ISO 9001:2015 प्रमाणित प्रक्रियाएँ।' },
      { t: 'एजाइल डिलीवरी', d: 'दो-हफ्ते के स्प्रिंट और पारदर्शी रिपोर्टिंग।' },
      { t: '24/7 सहायता', d: 'फ़ॉलो-द-सन इंजीनियरिंग और SLA सपोर्ट।' },
    ],
    stats: [
      { label: 'डिजिटल प्रोजेक्ट' }, { label: 'दुनिया भर में टेक प्रोफेशनल' },
      { label: 'सेवा किए गए क्लाइंट' }, { label: 'ग्लोबल बाज़ार' },
    ],
    gapKicker: '96% कंपनियाँ इस अंतर से जूझती हैं…',
    gapTitle: 'मजबूत आइडिया, कमज़ोर एग्ज़ीक्यूशन।',
    gapBody: 'हम केवल डिलिवरेबल देने वाली फर्म नहीं हैं। हम आपके विकास साझेदार हैं — रणनीति से लॉन्च तक परिणामों के मालिक।',
  },

  services: {
    kicker: 'एंड-टू-एंड IT सेवाएँ',
    title: 'वेब, सॉफ्टवेयर और डिजिटल मार्केटिंग सेवाएँ',
    body: 'आइडिया से एग्ज़ीक्यूशन तक, Hipro Technologies शक्तिशाली डिजिटल अनुभव बनाने में मदद करता है जो ग्राहकों को आकर्षित करें, ऑपरेशन बेहतर करें और लम्बे समय की वृद्धि बनाएँ।',
    childServices: 'शामिल सेवाएँ',
    items: {
      design: {
        tag: 'क्रिएटिव',
        title: 'डिज़ाइन और क्रिएटिव',
        subtitle: 'सुंदर, सहज डिजिटल अनुभव।',
        list: ['वेबसाइट डिज़ाइन', 'ग्राफ़िक डिज़ाइन', 'UI/UX डिज़ाइन', 'ब्रांड और पहचान', 'वीडियो प्रोडक्शन', 'सोशल मीडिया क्रिएटिव', 'मोशन ग्राफ़िक्स'],
      },
      development: {
        tag: 'लोकप्रिय',
        title: 'विकास और तकनीक',
        subtitle: 'मज़बूत, स्केलेबल ऐप्लिकेशन और सिस्टम।',
        list: ['मोबाइल ऐप डेवलपमेंट', 'ईकॉमर्स डेवलपमेंट', 'कस्टम सॉफ्टवेयर', 'वेब ऐप्लिकेशन', 'ERP/CRM समाधान', 'API इंटीग्रेशन', 'SaaS डेवलपमेंट'],
      },
      marketing: {
        tag: 'ज़्यादा माँग',
        title: 'मार्केटिंग और वृद्धि',
        subtitle: 'डेटा-आधारित रणनीतियाँ।',
        list: ['डिजिटल मार्केटिंग', 'परफ़ॉर्मेंस मार्केटिंग', 'SEO और GEO', 'मेटा एड्स', 'गूगल एड्स', 'लीड जनरेशन', 'सोशल मीडिया', 'कंटेंट मार्केटिंग'],
      },
      ai_automation: {
        tag: 'AI',
        title: 'AI और ऑटोमेशन',
        subtitle: 'स्मार्ट सिस्टम जो लागत घटाएँ और विकास बढ़ाएँ।',
        list: ['AI चैटबॉट और असिस्टेंट', 'वर्कफ़्लो ऑटोमेशन', 'डॉक्यूमेंट इंटेलिजेंस (OCR + LLM)', 'AI कैंडिडेट और लीड स्क्रीनिंग', 'प्रेडिक्टिव एनालिटिक्स और ML मॉडल', 'LLM इंटीग्रेशन और फ़ाइन-ट्यूनिंग'],
      },
      custom_software: {
        tag: 'कस्टम',
        title: 'कस्टम सॉफ़्टवेयर डेवलपमेंट',
        subtitle: 'आपके वर्कफ़्लो के अनुसार बना सॉफ़्टवेयर।',
        list: ['प्रोडक्ट डिस्कवरी और आर्किटेक्चर', 'SaaS प्लेटफ़ॉर्म', 'इंटरनल टूल्स और पोर्टल', 'API डिज़ाइन और इंटीग्रेशन', 'मल्टी-टेनेंट सिस्टम', 'QA और टेस्ट ऑटोमेशन'],
      },
      cloud_devops: {
        tag: 'स्केलेबल',
        title: 'क्लाउड और DevOps',
        subtitle: 'विश्वसनीय, सुरक्षित और किफ़ायती इंफ्रास्ट्रक्चर।',
        list: ['AWS / Azure / GCP आर्किटेक्चर', 'Kubernetes और कंटेनर', 'CI/CD पाइपलाइन', 'Infrastructure as Code (Terraform)', 'मॉनिटरिंग और ऑब्ज़र्वेबिलिटी', 'क्लाउड लागत अनुकूलन'],
      },
      data_analytics: {
        tag: 'डेटा-आधारित',
        title: 'डेटा और एनालिटिक्स',
        subtitle: 'कच्चे डेटा को भरोसेमंद निर्णयों में बदलें।',
        list: ['डेटा वेयरहाउस और पाइपलाइन', 'BI डैशबोर्ड', 'ETL / ELT इंजीनियरिंग', 'रीयल-टाइम एनालिटिक्स', 'डेटा गवर्नेंस और गुणवत्ता', 'कस्टमर 360 और रिपोर्टिंग'],
      },
      cybersecurity: {
        tag: 'सुरक्षित',
        title: 'साइबर सुरक्षा',
        subtitle: 'अपने ऐप, डेटा और प्रतिष्ठा की रक्षा करें।',
        list: ['सिक्योरिटी ऑडिट और पेन टेस्टिंग', 'सुरक्षित SDLC और कोड रिव्यू', 'आइडेंटिटी और एक्सेस मैनेजमेंट', 'SOC 2 / ISO 27001 / GDPR तैयारी', 'वल्नरेबिलिटी मैनेजमेंट', 'इंसिडेंट रिस्पॉन्स प्लानिंग'],
      },
      app_modernization: {
        tag: 'फ्यूचर-प्रूफ़',
        title: 'एप्लिकेशन आधुनिकीकरण',
        subtitle: 'लेगेसी सिस्टम को आधुनिक स्टैक पर ले जाएँ।',
        list: ['लेगेसी ऑडिट और रोडमैप', 'मोनोलिथ से माइक्रोसर्विसेज़', 'क्लाउड माइग्रेशन और री-प्लेटफ़ॉर्मिंग', 'लेगेसी ऐप का UI/UX रीवैम्प', 'डेटाबेस आधुनिकीकरण', 'ज़ीरो-डाउनटाइम माइग्रेशन'],
      },
      enterprise_solutions: {
        tag: 'एंटरप्राइज़',
        title: 'एंटरप्राइज़ समाधान',
        subtitle: 'बड़े संगठनों के लिए मिशन-क्रिटिकल प्लेटफ़ॉर्म।',
        list: ['ERP और CRM इम्प्लीमेंटेशन', 'HRMS और पेरोल सिस्टम', 'सप्लाई चेन और लॉजिस्टिक्स प्लेटफ़ॉर्म', 'एंटरप्राइज़ इंटीग्रेशन (SAP, Salesforce)', 'कस्टम वर्कफ़्लो इंजन', 'रोल-आधारित एक्सेस और अनुपालन'],
      },
      managed_it: {
        tag: '24/7',
        title: 'मैनेज्ड IT सेवाएँ',
        subtitle: 'बिना ओवरहेड के आपकी हमेशा-सक्रिय टेक टीम।',
        list: ['24/7 मॉनिटरिंग और सपोर्ट', 'SLA-आधारित मेंटेनेंस', 'हेल्पडेस्क और टिकटिंग', 'पैच और रिलीज़ मैनेजमेंट', 'बैकअप और डिज़ास्टर रिकवरी', 'समर्पित सपोर्ट इंजीनियर'],
      },
    },
  },

  portfolio: {
    kicker: 'पोर्टफोलियो',
    title: 'हाल के प्रोजेक्ट और सफलता की कहानियाँ',
    empty: 'इन फ़िल्टर से मेल खाते केस स्टडी नहीं। फ़िल्टर हटाएँ।',
  },

  tech: {
    kicker: 'टेक स्टैक और टूल्स',
    title: 'हम जो तकनीक इस्तेमाल करते हैं',
    body: 'हम आधुनिक भाषाओं, पैकेज और क्लाउड तकनीकों से स्केलेबल डिजिटल अनुभव बनाते हैं।',
  },

  industries: {
    kicker: 'हमारी विशेषज्ञता',
    title: 'हम जिन उद्योगों की सेवा करते हैं',
    body: 'गहरी उद्योग विशेषज्ञता के साथ विशेष सॉफ्टवेयर समाधान।',
    customKicker: 'कस्टम आवश्यकता?',
    customTitle: 'क्या आपका उद्योग सूचीबद्ध नहीं?',
    customBody: 'हम कई विशेष उद्योगों के लिए अनुकूलित सॉफ्टवेयर समाधान बनाते हैं।',
    items: {
      healthcare: { name: 'स्वास्थ्य', desc: 'HIPAA-अनुरूप हेल्थकेयर सॉफ्टवेयर, टेलीमेडिसिन और EHR प्लेटफ़ॉर्म।' },
      education: { name: 'शिक्षा', desc: 'आधुनिक LMS, ई-लर्निंग और स्कूल प्रबंधन प्लेटफ़ॉर्म।' },
      finance: { name: 'फ़ाइनेंस', desc: 'सुरक्षित फिनटेक उत्पाद, बैंकिंग और वेल्थ मैनेजमेंट।' },
      retail: { name: 'रिटेल', desc: 'आधुनिक ईकॉमर्स, POS और ऑम्निचैनल रिटेल समाधान।' },
      manufacturing: { name: 'निर्माण', desc: 'स्मार्ट ऑटोमेशन और इंडस्ट्री 4.0 सॉफ्टवेयर।' },
      realestate: { name: 'रियल एस्टेट', desc: 'प्रॉपर्टी प्रबंधन, लिस्टिंग पोर्टल और CRM।' },
      travel: { name: 'यात्रा', desc: 'OTA प्लेटफ़ॉर्म, बुकिंग इंजन और ट्रैवल प्रबंधन।' },
      automotive: { name: 'ऑटोमोटिव', desc: 'डीलर प्लेटफ़ॉर्म, फ्लीट और कनेक्टेड वाहन समाधान।' },
      technology: { name: 'तकनीक', desc: 'SaaS प्लेटफ़ॉर्म, डेवलपर टूल्स और एंटरप्राइज़ सॉफ्टवेयर।' },
    },
  },

  process: {
    kicker: 'सिद्ध एजाइल वर्कफ़्लो',
    title: 'हम कैसे काम करते हैं',
    body: 'स्केलेबल, सुरक्षित और उच्च-प्रदर्शन वाली वेबसाइट व ऐप्स के लिए विश्वसनीय एजाइल प्रक्रिया।',
    steps: {
      '01': { tag: 'खोज और स्कोप', title: 'आवश्यकताओं का विश्लेषण', items: ['व्यवसाय विश्लेषण', 'लक्षित यूज़र', 'आवश्यकताएँ', 'प्रोजेक्ट स्कोप'] },
      '02': { tag: 'वायरफ़्रेम और UI', title: 'UI/UX डिज़ाइन प्रक्रिया', items: ['वायरफ़्रेमिंग', 'UI डिज़ाइन', 'प्रोटोटाइपिंग', 'यूज़र टेस्टिंग'] },
      '03': { tag: 'फुल-स्टैक डेव', title: 'ऐप्लिकेशन विकास', items: ['कोड गुणवत्ता', 'वर्ज़न कंट्रोल', 'बेस्ट प्रैक्टिस', 'टेस्ट एकीकरण'] },
      '04': { tag: 'QA और सुरक्षा', title: 'गुणवत्ता परीक्षण', items: ['फ़ंक्शनल टेस्ट', 'प्रदर्शन', 'सुरक्षा', 'डिवाइस टेस्टिंग'] },
      '05': { tag: 'स्टोर और क्लाउड', title: 'डिप्लॉयमेंट', items: ['स्टोर सबमिशन', 'ऐप रिव्यू', 'ASO', 'लॉन्च'] },
      '06': { tag: '24/7 सहायता', title: 'सहायता और स्केलिंग', items: ['बग फ़िक्स', 'अपडेट', 'स्केलिंग', 'सहायता'] },
    },
    stepPrefix: 'चरण',
  },

  insights: {
    kicker: 'नवीनतम अपडेट', title: 'लेख और समाचार',
    body: 'डिजिटल मार्केटिंग, SEO, AI नवाचार और व्यवसाय विकास पर विशेषज्ञ लेख।',
  },

  faq: {
    kicker: 'सवाल हैं?', title: 'अक्सर पूछे जाने वाले सवाल',
    body: 'हमारी सेवाओं, प्रक्रियाओं और डिजिटल विकास को तेज़ करने के तरीक़ों के बारे में जानें।',
    clientKicker: 'क्लाइंट की बातें', clientTitle: 'क्लाइंट Hipro के बारे में क्या कहते हैं',
    shareYours: 'अपनी कहानी साझा करें',
  },

  cta: {
    kicker: 'शुरू करने के लिए तैयार?',
    titleA: 'अपनी', titleB: 'विकास यात्रा', titleC: 'साथ मिलकर बनाएँ',
    body: 'अपने व्यवसाय को ऑनलाइन ले जाने का सबसे अच्छा समय अभी है। सही पैकेज चुनें और हमारे विशेषज्ञों से WhatsApp पर बात करें।',
  },

  contactMap: {
    kicker: 'हमें खोजें',
    title: 'अपने नज़दीकी कार्यालय पर आएं',
    body: 'भारत, USA, UK, UAE, मलेशिया, नीदरलैंड और हांगकांग में 13 कार्यालय। मानचित्र पर देखने और एक टैप में दिशा-निर्देश पाने के लिए कोई स्थान चुनें।',
    directions: 'दिशा-निर्देश पाएं',
    nearest: 'आपके सबसे नज़दीक',
    useMyLocation: 'मेरी लोकेशन इस्तेमाल करें',
  },

  footer: {
    globalKicker: 'ग्लोबल उपस्थिति',
    globalTitle: 'दुनिया भर में हमारे कार्यालय',
    globalSub: '7 देशों में 13 कार्यालय — अपनी सबसे नज़दीकी Hipro टीम खोजें।',
    globalAll: 'सभी देश',
    officesLabel: 'कार्यालय',
    countriesLabel: 'देश',
    tagline: 'Hipro Technologies एक ISO-प्रमाणित वैश्विक IT सेवा कंपनी है — सॉफ्टवेयर इंजीनियरिंग, AI ऑटोमेशन, क्लाउड और डिजिटल मार्केटिंग परिणाम प्रदान करती है।',
    servicesTitle: 'सेवाएँ', companyTitle: 'कंपनी', contactTitle: 'संपर्क',
    servicesList: ['वेब डेवलपमेंट', 'मोबाइल ऐप डेवलपमेंट', 'कस्टम सॉफ्टवेयर डेवलपमेंट', 'AI और ऑटोमेशन', 'क्लाउड और DevOps', 'डेटा और एनालिटिक्स', 'साइबर सुरक्षा', 'एप्लिकेशन आधुनिकीकरण', 'एंटरप्राइज़ समाधान', 'मैनेज्ड IT सेवाएँ', 'डिजिटल मार्केटिंग और SEO'],
    companyList: ['हमारे बारे में', 'पोर्टफोलियो', 'उद्योग', 'लेख', 'करियर', 'संपर्क'],
    rightsReserved: 'सर्वाधिकार सुरक्षित।',
    privacy: 'गोपनीयता नीति', terms: 'सेवा की शर्तें', cookies: 'कुकी नीति',
  },

  book: {
    kicker: 'मीटिंग बुक करें',
    title: 'समय चुनें। आइडिया हमारे।',
    body: 'सीनियर कंसल्टेंट के साथ 30 मिनट की रणनीति कॉल। कोई दबाव नहीं — केवल स्पष्ट अगले क़दम।',
    pickDate: 'तारीख़ चुनें', pickSlot: 'उपलब्ध स्लॉट',
    loadingSlots: 'स्लॉट लोड हो रहे हैं…',
    slotNote: 'स्लॉट IST (भारतीय समय) में हैं। हर स्लॉट के नीचे आपका स्थानीय समय दिखता है — ✓ आपके लिए सुविधाजनक समय दर्शाता है।',
    fullName: 'पूरा नाम *', workEmail: 'कार्य ईमेल *', phone: 'फ़ोन', timezone: 'टाइमज़ोन',
    help: 'हम कैसे मदद कर सकते हैं?', helpPh: 'सेवा चुनें',
    notes: 'और कुछ बताना चाहेंगे?', notesPh: 'प्रोजेक्ट स्थिति, लक्ष्य, समय-सीमा…',
    yourBooking: 'आपकी बुकिंग', pickSlotPlaceholder: 'स्लॉट चुनें',
    autoTz: 'टाइमज़ोन पहचाना गया', nearest: 'नज़दीकी कार्यालय', yourTime: 'आपका समय',
    confirm: 'मीटिंग पक्की करें', confirming: 'पुष्टि हो रही है…',
    disclaimer: 'बुकिंग से आप कैलेंडर इनवाइट और फ़ॉलो-अप ईमेल प्राप्त करने की सहमति देते हैं। स्पैम नहीं।',
    booked: 'आपकी बुकिंग हो गई!',
    bookedBody: 'कैलेंडर इनवाइट आपके लिए आरक्षित है। इसे कैलेंडर में जोड़ें ताकि याद रहे।',
    downloadIcs: '.ics इनवाइट डाउनलोड करें',
    backToHome: 'होम पर जाएँ',
    reminder: 'हमारी टीम मीटिंग लिंक और संक्षिप्त ब्रीफ़ ईमेल पर भेजेगी।',
    confirmedToast: 'मीटिंग पक्की!',
    confirmedToastDesc: 'विवरण के लिए ईमेल देखें। कैलेंडर में जोड़ भी सकते हैं।',
    slotTaken: 'स्लॉट अभी बुक हुआ',
    slotTakenDesc: 'यह स्लॉट ले लिया गया। कृपया दूसरा चुनें।',
  },

  pricing: {
    kicker: 'पारदर्शी मूल्य',
    title: 'आपकी स्थानीय मुद्रा में पैकेज',
    body: 'आपकी लोकेशन से स्वतः पहचाना गया। कभी भी बदलें — हम USA, UK, EU, UAE, मलेशिया, हांगकांग और भारत के क्लाइंट के साथ काम करते हैं।',
    pricesShownIn: 'मूल्य दिखाए गए हैं',
    fxNote: 'आज के FX पर लगभग।',
    mostPopular: 'सबसे लोकप्रिय',
    bestFor: 'उपयुक्त:', delivery: 'डिलीवरी:',
    taxes: 'टैक्स शामिल नहीं। एंटरप्राइज़ और लंबे रिटेनर कस्टम-प्राइस्ड — विस्तृत प्रस्ताव के लिए कॉल बुक करें।',
  },

  testimonial: {
    hero: 'अपनी Hipro कहानी साझा करें',
    subtitle: 'हमारे साथ काम पसंद आया? एक छोटी टेस्टिमोनियल भेजें। नई एंट्रीज़ मॉडरेट होती हैं।',
    yourName: 'आपका नाम *', role: 'भूमिका', company: 'कंपनी', country: 'देश',
    feedback: 'आपकी प्रतिक्रिया *', feedbackPh: 'क्या अच्छा रहा और क्या बेहतर हो सकता है…',
    rating: 'रेटिंग',
    photo: 'आपकी फ़ोटो (वैकल्पिक)', logo: 'कंपनी लोगो (वैकल्पिक)',
    submit: 'टेस्टिमोनियल भेजें',
    thankTitle: 'धन्यवाद!',
    thankBody: 'आपकी टेस्टिमोनियल समीक्षा में है और स्वीकृत होने पर दिखाई देगी।',
    almost: 'लगभग हो गया', almostBody: 'कृपया नाम और एक संक्षिप्त उद्धरण जोड़ें।',
    tooLarge: 'चित्र बहुत बड़ा है', tooLargeBody: '1.2MB से कम रखें।',
  },

  caseStudy: {
    problem: 'समस्या',
    solution: 'हमारा समाधान',
    outcomes: 'मापने योग्य परिणाम',
    techStack: 'टेक स्टैक',
    similar: 'क्या आपका प्रोजेक्ट ऐसा है?',
    similarBody: '24 घंटों में मुफ़्त परामर्श और अनुमान पाएँ।',
    bookCall: 'कॉल बुक करें', seePricing: 'मूल्य देखें',
    team: 'टीम', duration: 'अवधि', client: 'क्लाइंट', industry: 'उद्योग',
    notFound: 'केस स्टडी नहीं मिला', notFoundBody: 'यह प्रोजेक्ट मौजूद नहीं है या स्थानांतरित हुआ है।',
  },
};

export default hi;
